import React from "react";

export type CRUDAction = "create" | "read" | "update" | "delete" | "list";

export const crudAll: CRUDAction[] = ["create", "read", "update", "delete", "list"];

export type CRUDStringLists = {
    list?: string[];
    read?: string[];
    update?: string[];
    create?: string[];
    delete?: string[];
};

export type ListDefaults = {
    sort: {
        name: string;
        direction: "asc" | "desc";
    };
    limit: number;
    offset: number;
};

type Defaults = {
    list: ListDefaults;
};

export type SelectOption = {
    value: number | string;
    text: string;
};

/// defines order of fields in tabbed forms
type TabbedOrder = {
    label: string;
    fields: string[];
}[];

/// a rule to disable a field based on the form values
export type FieldDisableRule = (formValues: Record<string, any>) => boolean;

export type Renderer = (value: any, row: any) => React.ReactNode;

export type ResourceDescriptor = {
    url: string;
    orders: CRUDStringLists;
    tabbedOrders?: {
        create: TabbedOrder;
        update: TabbedOrder;
    };
    crudActions?: CRUDAction[]; /// declares what actions are valid for this resource - sanity checking
    listDefaults?: ListDefaults;
    /// Format a resource row to be used in forms that select from this resource.
    /// (When the form handles a resource where this resource is a relation.)
    optionsFormatter?: (row: any) => SelectOption;
    enumTranslation?: Record<string, (value: string) => string>;
    disableRules?: {
        [action in CRUDAction]?: {
            [fieldName: string]: FieldDisableRule;
        };
    };
    renderers?: {
        read?: Record<string, Renderer>;
        list?: Record<string, Renderer>;
        delete?: Record<string, Renderer>;
    };
    /// these are used for create and update while renderers are used for the rest
    muiRenderers?: {
        create?: Record<string, React.FunctionComponent<any>>;
        update?: Record<string, React.FunctionComponent<any>>;
    };
    expand?: CRUDStringLists;
    identifiers?: string[];
    resourceSchemaPostProcessor?: (schema) => void;
    listParamPostProcess?: (params) => void;
};

export const defaults: Defaults = {
    list: {
        sort: {
            name: "id",
            direction: "asc",
        },
        limit: 20,
        offset: 0,
    },
};
